
'use client'

import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Phone, Mail, MapPin, ArrowUp } from 'lucide-react';
import './Footer.css'; // Import custom CSS for styling
import logo from "../../images/Travelicons/1d47d191b51c9563f83a9d045b8a6f63.png"
import logoCountries from "../../images/Travelicons/6f802ec4928efd14606a55c86c5afb46.png"
import line from "../../images/Travelicons/Line_(1)[1].svg"
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth', width:"20px" });
  };
  const pdf = "/Champs Travel Inc. Terms and conditions.pdf"
 
  return (
    <footer>
      {/* Main Footer Section */}
      <div className="footer-main py-5 d-flex  px-3">
        <Container>
          <Row className=" justify-content-between align-items-center">
            {/* Logo and Description Column */}
            <Col lg={4}>
            <img src={logo} style={{width:"150px"}} alt="" srcset="" />
              <h2 className="footer-logo mb-0  ">    </h2>
              <h6 className="footer-description mb-5 mt-0">
                We are committed to deliver the highest customer satisfaction rate in
                the Hajj & Umrah and youth camps industry.
               
              </h6>
              {/* <img src={logoCountries} alt="" srcset="" />   */}
            </Col>

            {/* Navigation Columns */}
            <Col lg={8}>
              <Row className='ps-md-5 ms-md-5 ps-0 ms-0 pt-3 pt-md-0'>
                {/* Useful Links Column */}
                <Col sm={4}>
                  <h5 className="footer-heading mb-0">Useful Links</h5>
                  <img src={line} alt="" srcset="" />
                  <ul className="footer-links">
                    <li>
                      <a href="/contact-us">Contact us</a>
                    </li>
                    <li>
  <a href="/terms-and-conditions" >
    Terms & Conditions
  </a>
</li>

                  </ul>
                </Col>

                {/* Navigations Column */}
                <Col sm={4}>
                  <h5 className="footer-heading mb-0">Navigations</h5>
                  <img src={line} alt="" srcset="" />
                  <ul className="footer-links">
                    <li>
                      <a href="/Listgallary">Previous Camps</a>
                    </li>
                    <li>
                      <a href="/ListUmrah">Umrah Camps</a>
                    </li>
                    <li>
                      <a href="/International?type=International Camps">International Camps</a>
                    </li>
                    <li>
                      <a href="/CanadaCamps?type=Canada camps">Canada Camps</a>
                    </li>
                  </ul>
                </Col>

                {/* Contact Us Column */}
                <Col sm={4}>
                  <h5 className="footer-heading mb-0">Contact Us</h5>
                  <img src={line} alt="" srcset="" />
                  <ul className="footer-links">
                    <li>
                      <a href="tel:+16472726035">
                        <Phone color='#FAD21A' size={16} />
                        +1(289) 919-3371
                      </a>
                    </li>
                    <li>
                      <a href="mailto:Sales@champstravel.ca">
                        <Mail color='#FAD21A' size={16} />
                        Sales@champstravel.ca
                      </a>
                    </li>
                    <li>
                      <div>
                        <MapPin color='#FAD21A' size={16} className='me-1' />
                        4145 N Service Rd, Burlington, <span className='ps-md-4 ps-0'>ON, Canada L7L, 6A3</span>
                      </div>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Copyright Bar */}
      <div className="footer-copyright py-2">
        <Container>
          <p className="text-center mb-0">
            Copyright © all rights reserved to Together Apps
          </p>
        </Container>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="scroll-to-top border-0"
      >
        <ArrowUp size={20} />
      </button>
    </footer>
  );
}